import axios, {AxiosResponse} from 'axios'

const api = '/api/general/'

const getCampuses = async () => {
  const response = await axios.get(`${api}get-campuses`)
  return response.data
}

// Start Impersonation
const startImpersonate = async ({data}) => {
  const response = await axios.post(`${api}start-impersonate`, data)
  return response.data
}

// Stop Impersonation
const stopImpersonate = async ({data}) => {
  const response = await axios.post(`${api}stop-impersonate`, data)
  return response.data
}

const getFaculties = async () => {
  const response = await axios.get(`${api}get-faculties`)
  return response.data
}

const getDepartments = async () => {
  const response = await axios.get(`${api}get-departments`)
  return response.data
}

const notifications = async () => {
  const response = await axios.get(`${api}notifications`)
  return response.data
}

const readNotification = async (id: string) => {
  const response = await axios.get(`${api}read-notification/${id}`)
  return response.data
}

const getUniversities = async () => {
  const response = await axios.get(`${api}get-universities`)
  return response.data
}

const getSchools = async () => {
  const response = await axios.get(`${api}get-schools`)
  return response.data
}

const getSchoolSubjects = async () => {
  const response = await axios.get(`${api}get-school-subjects`)
  return response.data
}

const getSchoolClasses = async () => {
  const response = await axios.get(`${api}get-school-classes`)
  return response.data
}

const getKankorTerms = async (id: string): Promise<AxiosResponse<any>> => {
  const response = await axios.get(`${api}get-kankor-terms/${id}`)
  return response.data
}

const getTerms = async (): Promise<AxiosResponse<any>> => {
  const response = await axios.get(`${api}get-terms`)
  return response.data
}

const getSubjectTypes = async () => {
  const response = await axios.get(`${api}get-subject-types`)
  return response.data
}

const getSemesters = async () => {
  const response = await axios.get(`${api}get-semesters`)
  return response.data
}

const getAcademicRanks = async () => {
  const response = await axios.get(`${api}get-academic-ranks`)
  return response.data
}

const getSessions = async () => {
  const response = await axios.get(`${api}get-sessions`)
  return response.data
}

const getDays = async () => {
  const response = await axios.get(`${api}get-days`)
  return response.data
}

const getEducationDegrees = async () => {
  const response = await axios.get(`${api}get-educations-degree`)
  return response.data
}

const getPositions = async () => {
  const response = await axios.get(`${api}get-positions`)
  return response.data
}

const getSubjects = async () => {
  const response = await axios.get(`${api}get-subjects`)
  return response.data
}

const getLanguages = async () => {
  const response = await axios.get(`${api}get-languages`)
  return response.data
}

const getRelatives = async () => {
  const response = await axios.get(`${api}get-relatives`)
  return response.data
}

const getProvinces = async () => {
  const response = await axios.get(`${api}get-provinces`)
  return response.data
}

const getDistricts = async () => {
  const response = await axios.get(`${api}get-districts`)
  return response.data
}

const getNationalities = async () => {
  const response = await axios.get(`${api}get-nationalities`)
  return response.data
}

const getCompanies = async () => {
  const response = await axios.get(`${api}get-companies`)
  return response.data
}

const getCurrencies = async () => {
  const response = await axios.get(`${api}get-currencies`)
  return response.data
}

const getFinanceIncomeCategories = async () => {
  const response = await axios.get(`${api}get-finance-income-categories`)
  return response.data
}

const getFinanceExpenseCategories = async () => {
  const response = await axios.get(`${api}get-finance-expense-categories`)
  return response.data
}

const getFinanceSubCategories = async (id: string): Promise<AxiosResponse<any>> => {
  const response = await axios.get(`${api}get-finance-sub-categories/${id}`)
  return response.data
}
//dphs
const getSchoolCompanies = async () => {
  const response = await axios.get(`${api}get-school-companies`)
  return response.data
}

const getSchoolFinanceIncomeCategories = async () => {
  const response = await axios.get(`${api}get-school-finance-income-categories`)
  return response.data
}

const getSchoolFinanceExpenseCategories = async () => {
  const response = await axios.get(`${api}get-school-finance-expense-categories`)
  return response.data
}

const getSchoolFinanceSubCategories = async (id: string): Promise<AxiosResponse<any>> => {
  const response = await axios.get(`${api}get-school-finance-sub-categories/${id}`)
  return response.data
}

const getSchoolPositions = async () => {
  const response = await axios.get(`${api}get-school-positions`)
  return response.data
}

const getClasses = async () => {
  const response = await axios.get(`${api}get-classes`)
  return response.data
}

const getClassRooms = async (id: string): Promise<AxiosResponse<any>> => {
  const response = await axios.get(`${api}get-class-rooms/${id}`)
  return response.data
}

const getPersianMonths = async () => {
  const response = await axios.get(`${api}get-persian-months`)
  return response.data
}

const getClassRoomStudents = async (
  school_class_id: string,
  class_room_id: string
): Promise<AxiosResponse<any>> => {
  const response = await axios.get(
    `${api}get-class-room-students/${school_class_id}/${class_room_id}`
  )
  return response.data
}

const getAcademicYearClasses = async (academic_year_id: string): Promise<AxiosResponse<any>> => {
  const response = await axios.get(`${api}get-academic-year-classes/${academic_year_id}`)
  return response.data
}

const getAcademicYearStudentClasses = async (id: string,year: string): Promise<AxiosResponse<any>> => {
  const response = await axios.get(`${api}get-academic-year-student-classes/${id}/${year}`)
  return response.data
}

const generalService = {
  getSessions,
  getAcademicRanks,
  getSubjectTypes,
  getSemesters,
  getKankorTerms,
  getTerms,
  getUniversities,
  getSchools,
  getSchoolSubjects,
  getSchoolClasses,
  readNotification,
  notifications,
  getCampuses,
  startImpersonate,
  stopImpersonate,
  getFaculties,
  getDepartments,
  getDays,
  getEducationDegrees,
  getPositions,
  getSubjects,
  getLanguages,
  getRelatives,
  getProvinces,
  getDistricts,
  getNationalities,
  getCurrencies,
  getCompanies,
  getFinanceIncomeCategories,
  getFinanceExpenseCategories,
  getFinanceSubCategories,
  //dphs
  getSchoolCompanies,
  getSchoolFinanceIncomeCategories,
  getSchoolFinanceExpenseCategories,
  getSchoolFinanceSubCategories,
  getSchoolPositions,
  getClasses,
  getPersianMonths,
  getClassRooms,
  getClassRoomStudents,
  getAcademicYearClasses,
  getAcademicYearStudentClasses,
}

export default generalService
